export default function getJobKeyFromUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  const urlObj = new URL(url);
  return urlObj.searchParams.get("jk");
}
